let searchDisplayModel = [
  {
    totalResults: 0,
    searchResults: [
      {
        id: 0,
        brandCode: "",
        brandEntity: "",
        brandName: "",
        title: "",
        city: "",
        stateProvince: "",
        postalCode: "",
        country: "",
        datePosted: "",
        expirationDate: ""
      }
    ]
  }
]

export default searchDisplayModel
